import axiosClient from './axiosClient'
const nationalityApi = {
  getAll: (params) => {
    const url = '/nationality/getAll'
    return axiosClient.get(url, { params })
  },
}
export default nationalityApi
